import { useCallback } from "react";
import axiosInstance from "../services/axiosIntercept";
import { useSelector } from "react-redux";
import * as selectors from "../selectors/selectors";
import { createPaymentLink } from "../services/stripeBillingService";
import { DEFAULT_BILLING_COUNTRY_CODE } from "../utils/localisedBilling";

export const useBillingStripe = () => {
  const accountUuid = useSelector(selectors.getAccountUuid);

  const getBillingStripe = async () => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}v1/stripe/customer/portal`,
        {
          accountUuid: accountUuid,
        },
        {
          withCredentials: true,
          headers: {
            "api-key": process.env.REACT_APP_API_KEY,
          },
        },
      );
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };

  return getBillingStripe;
};

export const useStripePaymentLink = () => {
  const accountUuid = useSelector(selectors.getAccountUuid);

  const getPaymentLink = useCallback(
    async (countryCode: string = DEFAULT_BILLING_COUNTRY_CODE) => {
      try {
        const response = await createPaymentLink({
          accountUuid: accountUuid ?? "",
          countryCode,
        });
        console.log(response);
        return response;
      } catch (error) {
        console.error("API Error:", error);
        throw error;
      }
    },
    [accountUuid],
  );

  return getPaymentLink;
};
